import { useState } from "react";
import { hostOf, monogramOf } from "@/lib/outlet";

export default function OutletFavicon({ url, outlet = "", size = 20, className = "" }) {
  const host = url ? hostOf(url) : null;
  const src = host ? `https://www.google.com/s2/favicons?domain=${host}&sz=64` : null;

  // The URL that failed, not a boolean.
  //
  // As a boolean this state was never reset when `url` changed, and these are
  // rendered from a keyed list — React reuses the component instance for the
  // next row in the same slot. So one outlet whose favicon 404'd left that grid
  // position showing a monogram for every article that scrolled through it
  // afterwards, however good their icons were. Comparing against the src that
  // failed makes the reset automatic: a new url is, by definition, not the one
  // that broke.
  const [failedSrc, setFailedSrc] = useState(null);
  const failed = src != null && failedSrc === src;

  const box = { width: size, height: size };

  if (!src || failed) {
    return (
      <span
        data-testid="outlet-favicon-fallback"
        className={`grid shrink-0 place-items-center rounded bg-ink font-sans font-bold text-paper ${className}`}
        style={{ ...box, fontSize: size * 0.5 }}
      >
        {monogramOf(outlet)}
      </span>
    );
  }

  return (
    <img
      data-testid="outlet-favicon"
      src={src}
      alt=""
      width={size}
      height={size}
      onError={() => setFailedSrc(src)}
      className={`shrink-0 rounded ${className}`}
      style={box}
    />
  );
}
